"use strict";

var _objectSpread = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _pick = _interopRequireDefault(require("ramda/src/pick"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var extractProps = (0, _pick.default)(['resizeMode', 'tintColor', 'overlayColor']);
function mapObjectFit(objectFit) {
  var resizeMode;
  switch (objectFit) {
    case 'contain':
    case 'cover':
      resizeMode = objectFit;
      break;
    case 'fill':
      resizeMode = 'stretch';
      break;
    case 'scale-down':
      resizeMode = 'contain';
      break;
    default:
      return null;
  }
  return {
    resizeMode: resizeMode
  };
}
function extractImageStyleProps(style, objectFit) {
  var resizeModeFromFit = objectFit ? mapObjectFit(objectFit) : null;
  return _objectSpread(_objectSpread({}, extractProps(style)), resizeModeFromFit);
}
var _default = extractImageStyleProps;
exports.default = _default;